import React, { useEffect, useState } from 'react';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';

interface TaskTypeEffortDialogProps {
  visible: boolean;
  onHide: () => void;
  taskTypeId: string | number | null;
  taskTypes: any;
  onSaveWeight: (taskTypeId: string | number, weight: number) => void;
}

const TaskTypeEffortDialog: React.FC<TaskTypeEffortDialogProps> = ({
  visible,
  onHide,
  taskTypeId,
  taskTypes,
  onSaveWeight
}) => {
  const currentTaskType = taskTypes?.find((tt: any) => tt.id === taskTypeId);
  const currentWeight = currentTaskType?.effort ?? 1;
  const [localWeight, setLocalWeight] = useState<string>(String(currentWeight));
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (visible && taskTypeId !== null) {
      const found = taskTypes?.find((tt: any) => tt.id === taskTypeId);
      setLocalWeight(String(found?.effort ?? 1));
      setError(null);
    }
  }, [visible, taskTypeId, taskTypes]);

  const validateWeight = (value: string): boolean => {
    const num = parseFloat(value.replace(',', '.'));
    
    if (value === '' || isNaN(num)) {
      setError('Введите число');
      return false;
    }
    if (num < 0.1) {
      setError('Значение не может быть меньше 0.1');
      return false;
    }
    if (num > 1) {
      setError('Значение не может быть больше 1');
      return false;
    }
    setError(null);
    return true;
  };

  const handleWeightChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalWeight(value);
    validateWeight(value);
  };

  const handleSave = () => {
    const num = parseFloat(localWeight.replace(',', '.'));
    if (!validateWeight(localWeight)) {
      return;
    }
    if (taskTypeId !== null && onSaveWeight) {
      onSaveWeight(taskTypeId, num);
    }
    onHide();
  };

  const isValid = !error && localWeight !== '' && parseFloat(localWeight.replace(',', '.')) >= 0.1 && parseFloat(localWeight.replace(',', '.')) <= 1;

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header="Настройка веса типа наряда в интервале"
      modal
      footer={
        <div className="flex justify-content-end gap-2">
          <Button label="Отмена" icon="pi pi-times" onClick={onHide} className="p-button-secondary" />
          <Button 
            label="Применить" 
            icon="pi pi-check" 
            onClick={handleSave}
            disabled={!isValid}
          />
        </div>
      }
    >
      <div className="flex flex-column gap-3 p-3">
        <div className="flex flex-column gap-2">
          <label htmlFor="weight">Вес типа наряда в интервале:</label>
          <InputText
            id="weight"
            value={localWeight}
            type="number"
            onChange={handleWeightChange}
            className={`w-full ${error ? 'p-invalid' : ''}`}
            step={0.1}
          />
          {error ?? (
            <small className="text-red-500">{error}</small>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default TaskTypeEffortDialog;